// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610141737/js/" + chunkId + "." + {"44":"38a7dced","225":"b04e95fc","481":"d94ec203","486":"bcf5a7c3","770":"b5af1b95"}[chunkId] + ".0.2751395432380762.chunk.js";
};